import { enableArrayMethods, enableMapSet } from "immer";

/** Optional flags for {@link initImmer}. Omitted keys default to `true`. */
export interface InitImmerOptions {
    mapSet?: boolean;
    arrayMethods?: boolean;
}

/**
 * Turns on Immer support for `Map`/`Set` and faster array helpers (`push`, `splice`, etc.).
 *
 * `createImmerStore` calls this for you, so app entry files do not need to import this module. Immer deduplicates the plugins calls for us.
 *
 * Call this yourself only when you use Immer or Zustand’s `immer` middleware **without**
 * `createImmerStore` (for example in a unit test). Run it once before those tests, e.g. in `beforeAll`.
 */
export function initImmer({ mapSet = true, arrayMethods = true }: InitImmerOptions = {}) {
    if (mapSet) enableMapSet();
    if (arrayMethods) enableArrayMethods();
}
